import { render, staticRenderFns } from "./OrderDetailsBox.vue?vue&type=template&id=7c22e19c&scoped=true"
import script from "./OrderDetailsBox.vue?vue&type=script&lang=js"
export * from "./OrderDetailsBox.vue?vue&type=script&lang=js"
import style0 from "./OrderDetailsBox.vue?vue&type=style&index=0&id=7c22e19c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c22e19c",
  null
  
)

export default component.exports